import { checkVariantCompat } from "./compat-bloom.module.js";

// default quantity
let quantity = 1;
// console.groupCollapsed('[AK] hydration'); console.log({dataBloom, dataUniversal, product}); console.groupEnd();
let currentCompatStatus = 'unknown';

/****************
 * URL Variant Management
 * Handles variant URLs and browser navigation
 ****************/

// Function to get variant ID from URL
function getVariantFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('variant');
}

// Function to update URL with current variant
function updateURL(variantId) {
    if (!variantId) return;
    
    const url = new URL(window.location);
    url.searchParams.set('variant', variantId);
    
    // Update URL without refreshing page
    window.history.replaceState({ variantId: variantId }, '', url);
    // console.log('[URL] Updated variant URL:', variantId, window.location.href);
}

// Function to set initial variant from URL
function setInitialVariantFromURL() {
    initializeCompatibilityDisplay();
    const variantId = getVariantFromURL();
    if (!variantId || !product || !product.variants) return false;
    
    // console.log('[URL] Attempting to set variant from URL:', variantId);
    
    // Find the variant in the product data
    const variant = product.variants.find(v => v.id == variantId);
    if (!variant) {
        // console.log('[URL] Variant not found:', variantId);
        return false;
    }
    
    // Set the activeVariant
    window.activeVariant = variant;
    // console.log('[URL] Set activeVariant from URL:', variant.id);
    
    // Update all the dropdowns to match this variant's options (if they exist)
    const dropdowns = document.querySelectorAll(".productOptionDropdown");
    if (dropdowns.length > 0) {
        dropdowns.forEach((dropdown, index) => {
            if (variant.options[index]) {
                dropdown.value = variant.options[index];
            }
        });
    }
    
    return true;
}

// Handle browser back/forward navigation
window.addEventListener('popstate', function(event) {
    if (event.state && event.state.variantId) {
        // Find and set the variant from the URL
        const variantId = event.state.variantId;
        const variant = product.variants.find(v => v.id == variantId);
        if (variant) {
            window.activeVariant = variant;
            // Update dropdowns to match
            const dropdowns = document.querySelectorAll(".productOptionDropdown");
            dropdowns.forEach((dropdown, index) => {
                if (variant.options[index]) {
                    dropdown.value = variant.options[index];
                }
            });
            // Update the product display
            updateProduct();
        }
    }
});

// Initialize variant from URL after everything is loaded
async function initializeVariantFromURL() {
    // console.log('[DEBUG] initializeVariantFromURL called at:', Date.now());
    
    // WAIT for vehicle system to be ready
    try {
        await window.Shopify.vehicle.vehicleReady;
        // console.log('[DEBUG] Vehicle system ready, proceeding with variant setup');
    } catch (error) {
        // console.warn('[DEBUG] Vehicle system failed, proceeding anyway:', error);
    }
    
    // Try to set variant from URL first
    const variantSetFromURL = setInitialVariantFromURL();
    
    // If we set a variant from URL, update the product display
    if (variantSetFromURL) {
        // console.log('[DEBUG] Variant set from URL, updating product');
        updateProduct();
    } else {
        // console.log('[DEBUG] No variant in URL, running normal updateProduct');
        updateProduct();
    }
}

/************
 Product Swiper
 ************/

// setup product swiper
let productImages = new Swiper("#productSwiper");

// thumbnail click
document.querySelectorAll(".productThumbnail").forEach(function (element) {
    element.addEventListener("click", function () {
        // determine index
        let index = getElIndex(this);

        // change active slide
        productImages.slideTo(index);
    });
});

// thumbnail change
productImages.on('slideChange', function (swiper) {
    document.querySelector(".productThumbnail.active").classList.remove("active");
    document.querySelectorAll(".productThumbnail")[swiper.realIndex].classList.add("active");

});

/*****************
 * Product Reviews / FAQ
 * *************/

document.querySelector('#productStars')?.addEventListener("click", function () {
    window.scroll({
        behavior: "smooth",
        top: document.querySelector("#reviews").offsetTop
    });
});
document.querySelector('[href="#reviews"]')?.addEventListener("click", function (e) {
    e.preventDefault();
    window.scroll({
        behavior: "smooth",
        top: document.querySelector("#reviews").offsetTop
    });
});

document.querySelector('[href="#faq"]')?.addEventListener("click", function (e) {
    e.preventDefault();
    window.scroll({
        behavior: "smooth",
        top: document.querySelector(".faq").offsetTop
    });
});

document.querySelector('[href="#hbspt-form"]')?.addEventListener("click", function (e) {
    e.preventDefault();
    window.scroll({
        behavior: "smooth",
        top: document.querySelector(".image-with-text").offsetTop
    });
});

/****************
 * Variant Switcher
 */

// sort dropdown
if (product.vendor === "ANBO") {
    for (let i = 0; i < productOptions.length; i++) {
        productOptions[i].values = productOptions[i].values.sort((a, b) => a.localeCompare(b, 'en', {numeric: true}));
    }
}

// Cache dropdown elements
const productOptionDropdowns = document.querySelectorAll(".productOptionDropdown");

// when a dropdown is changed, run update function
productOptionDropdowns.forEach(function (element) {
    element.addEventListener("change", function () {
        updateProduct();
    });
});

// saved price to skip fetch during bundle updates
let variantQuantityToPrice = {
    // [variantID-quantity]: price
};

//  get real price of variant
async function getFinalPrice(variantID, quantity) {
    // check if price is cached
    if (variantQuantityToPrice[`${variantID}-${quantity}`]) {
        return variantQuantityToPrice[`${variantID}-${quantity}`];
    }

    // unique id
    let uniqueID = new Date().getTime();

    // add the variant to the cart
    let lineItem = await addProduct({
        id: activeVariant.id,
        quantity: quantity,
        properties: {
            "_temp": uniqueID
        }
    });

    // save the price for caching
    variantQuantityToPrice[`${activeVariant.id}-${quantity}`] = lineItem.final_line_price;

    // remove the item from the cart (do not wait)
    changeProduct({
        id: lineItem.key,
        quantity: 0
    });

    return lineItem.final_line_price;
}

/**
 * Updates the product compatibility display based on the active vehicle and selected variant.
 */
async function updateProductCompatibilityDisplay() {
    // console.log('[COMPAT] Starting compatibility display update');

    if (!activeVariant?.id) {
        // console.log('[COMPAT] No active variant, skipping compatibility check');
        applyCompatibilityClasses('unknown');
        return;
    }

    const uniFit = dataUniversal[activeVariant.id];        // map from Liquid
    const bloom  = dataBloom[activeVariant.id];
  
    const universalEl  = document.getElementById('productUniversal');
    const compatEl     = document.getElementById('productCompatibility');
    const txtEl        = document.getElementById('productCompatibilityTxt');
    const icons        = document.querySelectorAll('.productCompatibilityIcon');
    const addVehPrompt = document.querySelector('.productAddVehicle');
  
    /* reset sections */
    [universalEl, compatEl, addVehPrompt].forEach(el=>el?.classList.remove('active'));
    icons.forEach(i=>i.classList.remove('active'));
  
    const veh   = window.Shopify?.vehicle?.activeVehicleDisplayData;
    const vehId = veh?.id;
    
    if (!vehId) {
        // console.log('[COMPAT] No vehicle selected, showing add vehicle prompt');
        document.querySelector('.productAddVehicle')?.classList.add('active');
        currentCompatStatus = 'unknown';
        applyCompatibilityClasses(currentCompatStatus);
        return;
    }
    
    const vehName = veh?.displayName || '';
    // console.log('[COMPAT] Checking compatibility for vehicle:', vehName, 'with variant:', activeVariant.id);

    let state;
  
    /* ---------- Universal fit ---------- */
    if (uniFit) {
        state = 'universal_fit';
        // console.log('[COMPAT] Product has universal fit');
    } else {
        /* ---------- Active variant ---------- */
        const thisFit = await checkVariantCompat(
            { bloom, universal: uniFit ? 'true' : 'false' },
            [vehId]
        );
        
        // console.log('[COMPAT] Active variant compatibility result:', thisFit);
  
        if (thisFit === 'compatible') {
            state = 'green';
        } else {
            /* ---------- Sibling variants ---------- */
            const siblingIds = Object.keys(dataBloom)
                                    .filter(id => id !== String(activeVariant.id));
  
            const siblingFits = await Promise.all(siblingIds.map(id =>
                checkVariantCompat(
                    { bloom: dataBloom[id], universal: dataUniversal[id] ? 'true':'false' },
                    [vehId]
                )
            ));
            
            const otherFit = siblingFits.includes('compatible');
            state = otherFit ? 'yellow' : 'red';
            // console.log('[COMPAT] Sibling variants check - other fits available:', otherFit);
        }
    }
    
    currentCompatStatus = state;
    // console.log('[COMPAT] Final compatibility status:', currentCompatStatus);
    
    // Apply CSS classes for state-specific styling
    applyCompatibilityClasses(currentCompatStatus);
    
    /* === UI rendering === */
    if(state==='universal_fit'){
        universalEl?.classList.add('active');
        const bodyTxt     = document.querySelector('.productUniversalBodyTxt');
        const bodyVehicle = document.querySelector('.productUniversalBodyVehicle');
        if (bodyTxt)     bodyTxt.innerHTML     = `Universal Fit – confirmed for your <button class="openVehicle" type="button">${vehName}</button>`;
        if (bodyVehicle) bodyVehicle.style.display = 'none';
        // console.log('[COMPAT] Applied universal fit UI');
        return;
    }
    
    compatEl?.classList.add('active');
    let msg;
    
    switch(state){
        case 'green':
            msg = `Compatible with your <button class="openVehicle" type="button">${vehName}</button>`;
            document
                .querySelector('.productCompatibilityIcon.compatible')
                ?.classList.add('active');
            // console.log('[COMPAT] Applied green compatibility UI');
            break;
        case 'yellow':
            msg = `This option isn't compatible, but other options fit your <button class="openVehicle" type="button">${vehName}</button>.`;
            document
                .querySelector('.productCompatibilityIcon.others')
                ?.classList.add('active');
            // console.log('[COMPAT] Applied yellow compatibility UI');
            break;
        default:
            msg=`Not Compatible with your <button class="openVehicle" type="button">${vehName}</button>.`;
            document
                .querySelector('.productCompatibilityIcon.none')
                ?.classList.add('active');
            // console.log('[COMPAT] Applied red compatibility UI');
    }
    
    if (txtEl) {
        txtEl.innerHTML = msg;
    }
    
    // console.log('[COMPAT] Compatibility display update completed');
}

// Enhanced vehicle change event listener
document.addEventListener('activeVehicleChanged', () => {
    // console.log('[COMPAT] Vehicle changed, updating compatibility display');
    updateProductCompatibilityDisplay();
});

// Enhanced vehicle ready event listener
window.Shopify.vehicle.vehicleReady.then(() => {
    // console.log('[COMPAT] Vehicle system ready, performing initial compatibility check');
    updateProductCompatibilityDisplay();
});

  
// update product
// update product
// update product
async function updateProduct() {
    // console.group('updateProduct');

    // 1. Capture the values currently in the dropdowns
    let options = [];
    productOptionDropdowns.forEach(dropdown => options.push(dropdown.value));
    
    // console.log('User selected:', options);

    // 2. Attempt #1: Find an EXACT match for all selected options
    activeVariant = product.variants.find(variant => {
        return JSON.stringify(variant.options) === JSON.stringify(options);
    });

    // 3. Fallback Logic (The Fix)
    if (!activeVariant) {
        // console.log('Exact match not found. Starting intelligent fallback...');

        // Attempt #2: Match Option 1 AND Option 2, ignoring Option 3.
        // This handles cases where the user changed Width (Opt 2), but the old Capacity (Opt 3) is invalid.
        // We want to find the first valid Capacity for the NEW Width.
        if (options.length >= 2) {
            activeVariant = product.variants.find(variant => 
                variant.option1 === options[0] && 
                variant.option2 === options[1]
            );
        }

        // Attempt #3: If that fails (or if there are only 2 options), match ONLY Option 1.
        // This handles cases where the user changed Mechanism (Opt 1), and the old Width/Capacity are invalid.
        if (!activeVariant) {
            // console.log('Option 1+2 match not found. Falling back to Option 1 default.');
            activeVariant = product.variants.find(variant => variant.option1 === options[0]);
        }
    }

    // based on the active variant's first option, find all possible variants that have the same first option
    let possibleVariants = product.variants.filter(variant => variant.option1 === activeVariant.option1);

    // determine allows options for option 2 and 3
    let allowedOptions = {
        "1": [], // Index 1 (Option 2)
        "2": []  // Index 2 (Option 3)
    };
    possibleVariants.forEach(variant => {
        allowedOptions["1"].push(variant.option2)
        allowedOptions["2"].push(variant.option3)
    });

    // generate dropdowns
    productOptions.forEach(function (option, index) {
        // save option index
        let optionIndex = index;

        // generate HTML
        let HTML = "";

        // generate options
        option.values.forEach(function (value, index) {
            // we don't check the first dropdown AND the option is not allowed
            if (optionIndex !== 0 && !allowedOptions[optionIndex].includes(value)) {
                return;
            }

            // generate option
            // We use the activeVariant options to ensure the dropdowns reflect the valid combination we found
            HTML += `<option value="${value.replaceAll('"', '&quot;')}" ${activeVariant.options[optionIndex] === value ? "selected" : ""}>${value}</option>`;
        });

        // update options
        document.querySelector(`#productOption${optionIndex}`).innerHTML = HTML;
    });

    // DOM Elements
    const productSKU = document.querySelector(".productInfoItemSku");
    const productWeight = document.querySelector(".productInfoItemWeight");
    const productATC = document.querySelector("#productATC");

    // check if variant is not found (Safety catch)
    if (!activeVariant) {
        // Mark as not available
        productATC.disabled = true;
        productATC.textContent = `Not Available`;
        // console.groupEnd();
        return;
    }

    // change image to match variant
    try {
        if (activeVariant.featured_media) {
            productImages.slideTo(activeVariant.featured_media.position - 1);
        }
    } catch (e) {
        // do nothing
    }

    // update meta info
    if (productSKU) productSKU.textContent = activeVariant.sku;
    if (productWeight) productWeight.textContent = `${(activeVariant.weight / 453.6).toFixed(1)} lb`;

    await updateProductCompatibilityDisplay(); // Call the new compatibility check function

    // Stock and availability (existing logic)
    const availableTxt = document.querySelector('#productAvailableTxt');
    if (!activeVariant.available) {
        if (availableTxt) {
            availableTxt.textContent = `Out of Stock`;
            availableTxt.classList.add('red');
            availableTxt.classList.remove('green');
        }
        if (productATC) {
            productATC.disabled = true;
            productATC.textContent = `Sold Out`;
        }
    } else {
            if (availableTxt) {
            availableTxt.textContent = 'Built To Order';
            availableTxt.classList.remove('red');
            availableTxt.classList.remove('green');
            // Check for "in-stock-delivery"
            if (typeof variantIDToDelivery !== 'undefined' && variantIDToDelivery[activeVariant.id]) {
                const deliveryData = variantIDToDelivery[activeVariant.id];
                if (deliveryData.handle === 'in-stock-delivery') {
                    availableTxt.textContent = `In Stock`;
                    availableTxt.classList.add('green');
                }
            }
        }
        if (productATC) {
            productATC.disabled = false;
            productATC.textContent = `Add To Cart`; // Default, will be updated by bundle logic if present
        }
    }

    // check for variant features
    // each variant can has 3 features (title+value)
    let variantFeatures = variantIDToFeatures[activeVariant.id];

    // loop over each feature
    Object.keys(variantFeatures).forEach(feature => {
        // Get title and value of the feature
        let title = variantFeatures[feature].title;
        let value = variantFeatures[feature].value;

        // get the element
        let featureElement = document.querySelector(`#${feature}`);
        featureElement.classList.remove("active");

        // check if both are valid (not empty)
        let valid = title !== "" && value !== "";
        if (valid) {
            // update the title and value
            featureElement.querySelector(".productFeaturesBodyItemTitle").textContent = title;
            featureElement.querySelector(".productFeaturesBodyItemTxt").textContent = value;

            // show it
            featureElement.classList.add("active");
        }
    });

    // check if there are any active key feature items
    let activeFeatures = document.querySelectorAll(".productFeaturesBodyItem.active");

    // if there are active key features, show the key features section
    document.querySelector(".productFeaturesBody").classList.remove("active");
    if (activeFeatures.length > 0) {
        document.querySelector(".productFeaturesBody").classList.add("active");
    }

    // check if there are active uses
    let activeUses = document.querySelectorAll(".productFeaturesUses.active");

    // if there are either active uses or active features, show the features section
    document.querySelector(".productFeatures").classList.remove("active");
    if (activeUses.length !== 0 || activeFeatures.length !== 0) {
        document.querySelector(".productFeatures").classList.add("active");
    }

    // Delivery Info
    if (typeof variantIDToDelivery !== 'undefined' && variantIDToDelivery[activeVariant.id]) {
        let deliveryData = variantIDToDelivery[activeVariant.id];
        let deliveryDate = deliveryData.date;
        let deliveryValid = deliveryData.valid === "true"; // ensure boolean
        let deliveryFreeShipping = deliveryData.free_shipping === "true"; // ensure boolean

        const deliveryShippingEl = document.querySelector('#productDeliveryShipping');
        const deliveryDateEl = document.querySelector('#productDeliveryDate');
        const deliverySectionEl = document.querySelector('#productDelivery');

        if (deliveryShippingEl) deliveryShippingEl.textContent = "";
        if (deliveryDateEl) deliveryDateEl.innerHTML = `Delivery By <strong>${deliveryDate}</strong>`;

        if (deliveryFreeShipping && deliveryShippingEl && deliveryDateEl) {
            deliveryShippingEl.textContent = "FREE";
            deliveryDateEl.innerHTML = `Delivery By <strong>${deliveryDate}</strong>`;
        }
        if (deliverySectionEl) {
            deliverySectionEl.classList.remove('active');
            if (deliveryValid) {
                deliverySectionEl.classList.add('active');
            }
        }
    }

    // check if this variant has product recs
    // hide all product recs
    // START: Updated logic for FBT and Quote Position
    const quoteElement = document.getElementById('productQuote');
    const quotePlaceholder = document.getElementById('product-quote-placeholder');
    const quoteOriginalParent = document.getElementById('productLeft');
    const productWrapper = document.getElementById('productWrapper');

    // Hide all FBT containers initially
    document.querySelectorAll('.productRecs').forEach(element => {
        element.classList.remove('active');
    });

    const hasFbt = variantIDToRecsEnabled[activeVariant.id] === "true";

    // Manage Review Quote Position based on FBT
    if (quoteElement && quotePlaceholder && quoteOriginalParent) {
        if (hasFbt) {
            // FBT EXISTS: Move quote back to left column if it's not there.
            if (quoteElement.parentElement !== quoteOriginalParent) {
                quoteOriginalParent.appendChild(quoteElement);
            }
            // Ensure FBT wrapper is visible and placeholder is not taking space
            if(productWrapper) productWrapper.style.display = 'block';
            quotePlaceholder.style.display = 'none';

            // Show the specific FBT container for the active variant
            document.querySelector(`#rec-${activeVariant.id}`)?.classList.add('active');

        } else {
            // NO FBT: Move quote to the right column placeholder.
            if (quoteElement.parentElement !== quotePlaceholder) {
                quotePlaceholder.appendChild(quoteElement);
            }
            // Hide FBT wrapper and show the quote in its new position
            if(productWrapper) productWrapper.style.display = 'none';
            quotePlaceholder.style.display = 'block';
        }
    }
    // END: Updated logic for FBT and Quote Position
    // update price
    let activePrice = activeVariant.price;
    let activeCompare = activeVariant.compare_at_price;

    // check for bundle
    if (document.querySelector("#productBundles")) {

        // update each bundle item based on the current variant
        for (const element of document.querySelectorAll(".productBundlesItem")) {
            // get discount and quantity metafields
            let discount = parseInt(element.dataset.discount);
            let quantity = parseInt(element.dataset.quantity);
            let badge = element.dataset.badge.toLowerCase();

            // calculate prices
            let originalLinePrice = activeVariant.price * quantity;
            let finalLinePrice = discount === 0 ? originalLinePrice : await getFinalPrice(activeVariant.id, quantity);
            let finalLineSavings = originalLinePrice - finalLinePrice;

            // store compute price as data attribute
            element.dataset.price = finalLinePrice;

            // update fields
            if (finalLineSavings <= 0) {
                element.querySelector(".productBundlesItemBodySave").textContent = "";
                element.querySelector(".productBundlesItemBodyPriceCompare").textContent = "";
            } else {
                element.querySelector(".productBundlesItemBodySave").textContent = `Save ${price(finalLineSavings)}`;
                element.querySelector(".productBundlesItemBodyPriceCompare").textContent = price(originalLinePrice);
            }

            // if the badge is FREE, then we don't show the price
            if (badge === "free") {
                element.querySelector(".productBundlesItemBodyPriceFinal").textContent = "FREE";
            } else {
                element.querySelector(".productBundlesItemBodyPriceFinal").textContent = price(finalLinePrice);
            }
        }


        // find the active bundle item
        let activeBundleItem = document.querySelector(".productBundlesItem.active");

        // update product offer (limited time offer)
        // the offer tag should only show if it's enabled and if there is a price difference
        const _bundleDiscountPct = activeBundleItem ? parseFloat(activeBundleItem.dataset.discount || '0') : 0;
        const offerEnabled =
            productOfferData.enabled === "true" &&
            ((activeVariant.compare_at_price > activeVariant.price) || (_bundleDiscountPct > 0));

        const offerEl = document.querySelector('#productOffer');
        if (offerEl) offerEl.classList.toggle('active', !!offerEnabled);


        // if we're using bundle items, use that as the price instead
        if (activeBundleItem) {
            // NOTE: dataset values are strings → normalize to numbers (cents)
            const bundleQty         = parseInt(activeBundleItem.dataset.quantity || quantity, 10) || 1;
            const bundlePriceCents  = parseInt(activeBundleItem.dataset.price    || '0', 10) || 0;
            const bundleDiscPct     = parseFloat(activeBundleItem.dataset.discount || '0') || 0;

            // Base totals (before any bundle discount)
            const basePriceTotal    = (activeVariant.price || 0) * bundleQty;                 // cents
            const baseCompareTotal  = (activeVariant.compare_at_price || 0) * bundleQty;      // cents (0 when no sale)

            // Final price is what we computed for the bundle line
            activePrice = bundlePriceCents;

            // Compare precedence:
            //  1) Preserve product-level sale (compare_at_price) across the bundle quantity
            //  2) Else if bundle discounts apply, show pre-discount subtotal (price*qty)
            //  3) Else (no sale/discount), suppress compare by matching price (UI hides it)
            if (baseCompareTotal > 0) {
                activeCompare = baseCompareTotal;   // keep the "Limited time deal" strike-through
            } else if (bundleDiscPct > 0) {
                activeCompare = basePriceTotal;     // strike through the pre-discount subtotal
            } else {
                activeCompare = bundlePriceCents;   // no compare — UI will hide it
            }
        }
    }

    // update price
    document.querySelector('#productPriceReal').textContent = price(activePrice * quantity);
    document.querySelector('#productPriceSavings').textContent = '';
    document.querySelector('#productCompare').classList.remove('active');
    if (activeCompare > activePrice) {
        document.querySelector('#productPriceSavings').textContent = `-${price((activeCompare * quantity) - (activePrice * quantity))}`;
        document.querySelector('#productCompare s').textContent = price(activeCompare * quantity);
        document.querySelector('#productCompare').classList.add('active');
    }

    // update approve widget data
    document.querySelector('#productPriceFinance').setAttribute('approve-price', activePrice / 100);
    document.querySelector('#productPriceFinance').setAttribute('approve-qty', quantity);
    document.querySelector('#productPriceFinance').setAttribute('approve-model', product.title + " | " + activeVariant.title);
    document.querySelector('#productPriceFinanceRate').setAttribute('approve-total', activePrice * quantity / 100);

    // fallback to normal (update button)
    productATC.textContent = `Add To Cart`;

    // *** ADD URL UPDATE HERE ***
    updateURL(activeVariant.id);
    // console.groupEnd();
}

/*********************
 Product Bundles
 *********************/

// allow people to switch active bundle item
document.querySelectorAll(".productBundlesItem").forEach(element => {
    element.addEventListener("click", function () {
        // remove active class from all
        document.querySelectorAll(".productBundlesItem").forEach(element => {
            element.classList.remove("active");
        });

        // add active class to this one
        this.classList.add("active");

        // update price
        updateProduct();
    });
})

/**************
 Product Quantity
 ***************/


// minus
document.querySelector(".productQuantityBtn.minus")?.addEventListener("click", function () {
    if (quantity === 1) {
        return;
    }
    quantity--;
    document.querySelector(".productQuantityValue").textContent = quantity;
    updateProduct();
});

// plus
document.querySelector(".productQuantityBtn.plus")?.addEventListener("click", function () {
    quantity++;
    document.querySelector(".productQuantityValue").textContent = quantity;
    updateProduct();
});


/**************
 Product ATC
 ***************/

// atc event listener
document.querySelector("#productATC").addEventListener("click", async function () {
    // add loading animation
    document.querySelector("#productATC").classList.add("loading");

    // check for override, bundle
    if (document.querySelector(".productBundlesItem.active")) {
        quantity = parseInt(document.querySelector(".productBundlesItem.active").dataset.quantity);
    }

    let formData = {
        id: activeVariant.id,
        quantity: quantity,
        properties: {
            '_compat_status': currentCompatStatus
        }
    }

    try {
        // 1. Add the product
        await addProduct(formData);

        // 2. *** Explicitly update the global state ***
        await fetchAndUpdateCart();

        // 3. Open the cart (will now use the fresh global state)
        await openCart();

    } catch (error) {
        console.error("Error during Add to Cart process:", error);
        // Optionally show an error to the user
    } finally {
        setTimeout(function () {
            document.querySelector("#productATC").classList.remove("loading");
        }, 500); // Consider removing/reducing this timeout if not needed
    }
});

/**************
 Recs ATC
 ***************/
 document.querySelectorAll('.productRecsBodyItemATC').forEach(element => {
    element.addEventListener('click', async function () {
        // add loading animation
        element.classList.add("loading");

        let formData = {
            id: parseInt(element.dataset.id),
            quantity: 1
        }

        const lineItem = await addProduct(formData);
        
        // Open cart with skipFetch=true since we've already updated the cart object
        await openCart(true);

        // remove loading animation
        setTimeout(function () {
            element.classList.remove("loading");
        }, 500);
    });
});


/**************
 Product Tabs
 ***************/

document.querySelectorAll("div.productTab").forEach(function (element) {
    element.addEventListener("click", function () {
        //is this current one open, if so close
        if (this.classList.contains("active")) {
            this.classList.remove("active");
        } else {
            //check if already open
            if (document.querySelector(".productTab.active")) {
                document.querySelector(".productTab.active").classList.remove("active");
            }
            this.classList.add("active");
        }
    });
});

/***********
 * Sticky ATC
 */

// sticky must be enabled
if (document.querySelector("#stickyATC")) {
    // show/hide
    window.addEventListener("scroll", function () {
        if (window.scrollY > document.querySelector("#productATC").offsetTop + document.querySelector("#productATC").offsetHeight) {
            document.querySelector("#stickyATC").classList.add("active");
        } else {
            document.querySelector("#stickyATC").classList.remove("active");
        }
    });

    // click
    document.querySelector("#stickyATC").addEventListener("click", function () {
        window.scroll({
            behavior: "smooth",
            top: document.querySelector("#productTitle").offsetTop
        })
    })
}


/* =============================================================================
   PRODUCT PAGE COMPATIBILITY CLASS MANAGEMENT
   Additions to maltertech-product.js for CSS state management
   ============================================================================= */

/**
 * Applies CSS classes to the document body based on current compatibility status
 * This enables state-specific styling for compatibility elements
 * 
 * @param {string} status - The current compatibility status ('green', 'yellow', 'red', 'universal_fit', 'unknown')
 */
function applyCompatibilityClasses(status) {
    // Remove all existing compatibility classes from body
    const compatibilityClasses = [
        'product-compat-green',
        'product-compat-yellow', 
        'product-compat-red',
        'product-compat-universal',
        'product-compat-unknown',
        'product-compat-no-vehicle'
    ];
    
    document.body.classList.remove(...compatibilityClasses);
    
    // Apply the appropriate class based on status
    switch(status) {
        case 'green':
            document.body.classList.add('product-compat-green');
            // console.log('[COMPAT] Applied green compatibility styling');
            break;
        case 'yellow':
            document.body.classList.add('product-compat-yellow');
            // console.log('[COMPAT] Applied yellow compatibility styling');
            break;
        case 'red':
            document.body.classList.add('product-compat-red');
            // console.log('[COMPAT] Applied red compatibility styling');
            break;
        case 'universal_fit':
            document.body.classList.add('product-compat-universal');
            // console.log('[COMPAT] Applied universal fit styling');
            break;
        case 'unknown':
        default:
            // Check if there's an active vehicle to determine appropriate unknown state
            const veh = window.Shopify?.vehicle?.activeVehicleDisplayData;
            const vehId = veh?.id;
            
            if (!vehId) {
                document.body.classList.add('product-compat-no-vehicle');
                // console.log('[COMPAT] Applied no-vehicle styling');
            } else {
                document.body.classList.add('product-compat-unknown');
                // console.log('[COMPAT] Applied unknown compatibility styling');
            }
            break;
    }
}

/* =============================================================================
   MODIFICATIONS TO EXISTING updateProductCompatibilityDisplay FUNCTION
   Add the following lines to your existing function
   ============================================================================= */

// ADD THIS NEAR THE END OF updateProductCompatibilityDisplay(), 
// AFTER currentCompatStatus IS SET BUT BEFORE THE UI RENDERING SECTION

// Apply CSS classes for state-specific styling


/* =============================================================================
   COMPLETE MODIFIED updateProductCompatibilityDisplay FUNCTION
   Replace your existing function with this enhanced version
   ============================================================================= */

/**
 * Enhanced updateProductCompatibilityDisplay with CSS class management
 * Updates the product compatibility display based on the active vehicle and selected variant.
 */


/* =============================================================================
   ADDITIONAL EVENT LISTENERS
   Ensure compatibility classes are updated when vehicle changes
   ============================================================================= */


/**
 * Initialize compatibility styling on page load
 */
function initializeCompatibilityDisplay() {
    // console.log('[COMPAT] Initializing compatibility display system');
    
    // Set initial state as unknown until vehicle system is ready
    applyCompatibilityClasses('unknown');
    
    // The vehicle system will trigger updates when ready
    // console.log('[COMPAT] Compatibility display system initialized');
}

document.addEventListener('DOMContentLoaded', () => {
    initializeVariantFromURL();
});